"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customDirectSelect = void 0;
const mapbox_gl_draw_1 = __importDefault(require("@mapbox/mapbox-gl-draw"));
const common_selectors_1 = require("@mapbox/mapbox-gl-draw/src/lib/common_selectors");
const constants_1 = require("@mapbox/mapbox-gl-draw/src/constants");
const FabricDrawingModes_1 = require("../FabricDrawingModes");
// Much of this borrowed from here:
// https://github.com/zakjan/mapbox-gl-draw-waypoint/blob/master/src/modes/direct_select.js
const { direct_select } = mapbox_gl_draw_1.default.modes;
const customDirectSelect = (preventDrag = false) => {
    // if we're not preventing drag, use built-in function
    if (!preventDrag)
        return direct_select;
    const CustomDirectSelect = Object.assign({}, direct_select);
    CustomDirectSelect.clickInactive = function (state, e) {
        if (e.featureTarget.geometry.type !== constants_1.geojsonTypes.POINT) {
            // Select the inactive feature when clicked
            this.changeMode(FabricDrawingModes_1.DrawingMode.DIRECT_SELECT, {
                featureId: e.featureTarget.properties.id,
            });
        }
        else {
            // Select the point if it's a point
            this.changeMode(FabricDrawingModes_1.DrawingMode.SIMPLE_SELECT, {
                featureIds: [e.featureTarget.properties.id],
            });
        }
    };
    CustomDirectSelect.clickActiveFeature = function (state) {
        // This just prevents the cursor from changing on a click then
        // calls the built-in method. Not super nice, but 🤷‍♂️.
        this.updateUIClasses({ mouse: constants_1.cursors.NONE });
        // call original
        direct_select.clickActiveFeature.call(this, state);
    };
    CustomDirectSelect.onTouchStart = CustomDirectSelect.onMouseDown = function (state, e) {
        // This just prevents the cursor from changing on mousedown then
        // calls the built-in method. Not super nice, but 🤷‍♂️.
        this.updateUIClasses({ mouse: constants_1.cursors.NONE });
        // call original
        direct_select.onMouseDown.call(this, state, e);
    };
    CustomDirectSelect.dragFeature = function () {
        // Do nothing on purpose
    };
    CustomDirectSelect.onMouseMove = function (state, e) {
        // This handles setting the cursor properly when you move over the map. Since
        // we are disabling moving, we don't want to show the ↕ arrows when moving
        // is disabled.
        const result = direct_select.onMouseMove.call(this, state, e);
        // Make our cursor right based on what's going on
        // show pointer cursor on inactive features, move cursor on active feature vertices
        const isFeature = (0, common_selectors_1.isInactiveFeature)(e);
        const onVertex = (0, common_selectors_1.isOfMetaType)(constants_1.meta.VERTEX)(e);
        const onMidpoint = (0, common_selectors_1.isOfMetaType)(constants_1.meta.MIDPOINT)(e);
        if (isFeature || onMidpoint) {
            this.updateUIClasses({ mouse: constants_1.cursors.POINTER });
        }
        else if (onVertex) {
            this.updateUIClasses({ mouse: constants_1.cursors.MOVE });
        }
        else {
            this.updateUIClasses({ mouse: constants_1.cursors.NONE });
        }
        return result;
    };
    return CustomDirectSelect;
};
exports.customDirectSelect = customDirectSelect;
exports.default = exports.customDirectSelect;
